import styled from 'styled-components';

export const FormText = styled.div.attrs({})`
  color: ${(props) => props.theme.palette.colors.grey};
  font-family: Kumbh Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
`;

export const RegisterContent = styled.div.attrs({})`
  background: ${(props) => props.theme.palette.colors.white};
  width: 100%;
  padding: 40px;

  height: 100%;
  display: flex;
  gap: 16px;
  flex-direction: column;
  margin-top: 60px;
  @media (max-width: 767px) {
    padding: 20px;
  }
`;
